import React from 'react';
import {Button, Form, FormGroup, Input, Container, Row, Col, InputGroup, InputGroupAddon} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import logo from '../../../assets/images/logo.png';
import { observer, inject } from 'mobx-react';
import FontAwesome  from "react-fontawesome";
import { Redirect } from 'react-router-dom'
import {checkAuth} from "../../../utils/security";
import loading from '../../../assets/images/ajax-loader.gif';

@inject("store")
@observer
export class Login extends React.Component {

    constructor(props){
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.store.loginStore;
    }

    componentWillMount() {
        this.logging = false;
    }

    componentDidMount() {
        this.usuarioInput.focus();
    }

    render() {
        return (
			<div>
                {checkAuth() && <Redirect to="/solicitacoes-pendentes" />}
				<div className="login-container">
					<div className="panel">
						<div className="panel-heading" style={{backgroundColor:'#00477f'}}>
							<a href="">
								<img src={logo} alt="logo"
									 className="block-center img-rounded"/>
							</a>
						</div>
						<div className="panel-body">
							<div className="login-form">
								<form onSubmit={(event) => this.controller.login(event)}>
									<FormGroup className="form-group has-feedback">
										<InputGroup>
											<Input value={this.controller.usuario} getRef={(input) => { this.usuarioInput = input; }} onChange={(event) => this.controller.setUsuario(event.target.value)} placeholder="Usuário" style={{marginRight: 'none'}} required="required"/>
											<InputGroupAddon className="InputGroupAddon-white">
												<FontAwesome name="user-o" />
											</InputGroupAddon>
										</InputGroup>
									</FormGroup>
									<FormGroup className="form-group has-feedback">
										<InputGroup>
											<Input value={this.controller.senha} onChange={(event) => this.controller.setSenha(event.target.value)} type="password" placeholder="Senha" required="required" style={{marginRight: 0}} />
											<InputGroupAddon className="InputGroupAddon-white">
												<FontAwesome name="lock" />
											</InputGroupAddon>
										</InputGroup>
									</FormGroup>
									<p style={{color: "red"}}>{this.controller.mensagemErro}</p>
									<Button type="submit" color="primary" block disabled={this.controller.logging}>{this.controller.logging ? <img src={loading} alt="loading" className="logging"/> : "Entrar"}</Button>
								</form>
							</div>
						</div>
						<p className="text-center">
							&copy; 2026 - Globo
						</p>
					</div>
				</div>
			</div>
        );
    }
}
